import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import { DropTarget, DragSource } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import oldType from '@helpers/oldType';
import { Brandfolder, Collection } from '@helpers/show_page_helpers';
import Card from './card';
import SectionsContext from '../sectionsContext';

class Asset extends React.PureComponent {
  componentDidMount() {
    this.props.connectDragPreview(getEmptyImage(), {
      captureDraggingState: true,
    });
  }

  get leftArrow() {
    return document.getElementsByClassName("left")[0];
  }

  get rightArrow() {
    return document.getElementsByClassName("right")[0];
  }

  visitAsset = (assetKey) => {
    // Note: DO NOT USE PROPS since these need to be dynamic during Navigation after the first asset is shown, must be done in jQuery to play nicely with existing asset pipeline functions
    const { parentBrandfolders, section } = this.props;
    const slug = Brandfolder.slug ? Brandfolder.slug : parentBrandfolders.find((brandfolder) => (
      brandfolder.id === section.brandfolder_id
    )).slug;
    const assetType = oldType(section.default_asset_type);
    const assetName = assetKey ? document.getElementById(`${assetKey}`).getElementsByClassName("asset-name")[0].innerHTML : "";
    const sectionKey = section.section_key;
    const urlParamsObj = {};

    if (Collection.slug) {
      urlParamsObj.collection_slug = Collection.slug;
    }

    if (BFG.manifestDigest) {
      urlParamsObj.manifest_digest = BFG.manifestDigest;
    } else {
      urlParamsObj.edit = true;
    }

    const urlBaseString = `${window.location.protocol}//${window.location.host}/${slug}/sections/${sectionKey}/ui/${assetType}/${assetKey}`;
    const urlParamsString = Object.keys(urlParamsObj).map((param) => `${param}=${urlParamsObj[param]}`).join('&');
    const url = `${urlBaseString}?${urlParamsString}`;

    BF.fullModal = true;
    BF.dialog.render(
      encodeURIComponent(assetName),
      url,
      BF.handlerGroups.showAsset
    );
    this.handleNextAssetNavigation(assetKey);
    this.handlePreviousAssetNavigation(assetKey);
    this.registerKeyBindingEvents(assetKey);
    this.sendInsights(assetKey);
  };

  handleSelectionClick = (e) => {
    e.stopPropagation();
    e.persist();
    if (e.shiftKey) {
      this.props.shiftSelect(this.props.asset.id, this.props.position);
    } else {
      this.props.toggleSelected(this.props.asset.id);
    }
  };

  editAsset = () => {
    const { asset, section } = this.props;
    const sectionKey = section.section_key;
    const assetType = oldType(asset.attributes.type);
    const urlBaseString = `${Brandfolder.slug}/sections/${sectionKey}/ui/${assetType}/${asset.id}?edit=true`;
    const urlParamsString = Collection.slug ? `&collection_slug=${Collection.slug}` : "";
    const url = urlBaseString + urlParamsString;

    if (window.getComputedStyle(this.rightArrow).display === "block") {
      this.rightArrow.style.display = "none";
      this.leftArrow.style.display = "none";
    }

    BF.fullModal = true;
    BF.dialog.render(
      encodeURIComponent(`${asset.attributes.name}`),
      url,
      BF.handlerGroups.showAsset,
      "edit"
    );
  };

  closeModal() {
    const $rightArrow = $(".modal-content .right");
    const $leftArrow = $(".modal-content .left");
    $rightArrow.hide();
    $leftArrow.hide();
    document.getElementsByClassName("close")[0].click();
  }

  handleNextAssetNavigation(assetKey) {
    /* Note: DO NOT USE PROPS since these need to be dynamic during Navigation
    after the first asset is shown, must be done in jQuery to play nicely with
    existing asset pipeline functions */
    const nextAsset = document.getElementById(`${assetKey}`).nextElementSibling;
    const nextAssetKey = nextAsset ? nextAsset.getAttribute("id") : null;
    /* NOTE for some reason replacing this with addEventListener/removeEventListener
    had different effects that's why there's still jquery here */
    const $rightArrow = $(".modal-content .right");
    $rightArrow.show();
    $rightArrow.unbind("click");
    $rightArrow.on("click", (e) => {
      e.preventDefault();
      if (nextAssetKey) {
        this.visitAsset(nextAssetKey);
      } else {
        this.closeModal();
      }
    });
  }

  handlePreviousAssetNavigation(assetKey) {
    /* Note: DO NOT USE PROPS since these need to be dynamic during Navigation
     after the first asset is shown, must be done in jQuery to play nicely
     with existing asset pipeline functions */
    const previousAsset = document.getElementById(`${assetKey}`)
      .previousSibling;
    const previousAssetKey = previousAsset
      ? previousAsset.getAttribute("id")
      : null;
    /* NOTE for some reason replacing this with addEventListener/removeEventListener
      had different effects that's why there's still jquery here */
    const $leftArrow = $(".modal-content .left");
    $leftArrow.show();
    $leftArrow.unbind("click");
    $leftArrow.on("click", (e) => {
      e.preventDefault();
      if (previousAssetKey) {
        this.visitAsset(previousAssetKey);
      } else {
        this.closeModal();
      }
    });
  }

  registerKeyBindingEvents(assetKey) {
    // Call next and previous on arrow key
    document.onkeydown = (_e) => {
      const e = _e || window.event;
      if (
        e.target.tagName.toUpperCase() !== "TEXTAREA"
        && e.target.tagName.toUpperCase() !== "INPUT"
        && !$(e.target).hasClass('trumbowyg-editor')
      ) {
        // TODO: `asset-edit-form` is not getting properly locked for changes when editing.
        // This prevents the "Are you sure?" alert from firing when trying to close the
        // asset modal with unsaved changes. We should fix this at some point.
        if (
          document.getElementById("asset-edit-form")
          && document.getElementById("asset-edit-form")[0].dataset.lockedForchanges
          && (e.keyCode === 39 || e.keyCode === 37)
        ) {
          BF.Asset.checkForEdits(e.keyCode, assetKey);
        } else if (e.keyCode === 39) {
          this.rightArrow.click();
        } else if (e.keyCode === 37) {
          this.leftArrow.click();
        } else if (e.keyCode === 27) {
          this.closeModal();
        }
      }
    };
  }

  sendInsights(assetKey) {
    Insight.createEvent('viewed', assetKey, "asset");
  }

  render() {
    const {
      asset,
      section,
      selected,
      reorderable,
      connectDropTarget,
      connectDragSource,
      isHovered,
      insertCaretDirection,
      onDragComplete,
      enableContactSheets
    } = this.props;

    return (
      <SectionsContext.Consumer>
        {({
          editable,
          listView,
          downloadable,
          activeLabelKey,
          activeLabelName,
          labelsDrawerOpen,
        }) => {
          let content = (
            <div
              className="card-wrapper"
              id={asset.id}
              data-name={asset.attributes.name}
              data-type={oldType(section ? section.default_asset_type : '')}
              data-section={section ? section.section_key : ''}
            >
              <Card
                asset={asset}
                editable={editable}
                downloadable={downloadable}
                editAsset={this.editAsset}
                handleSelectionClick={this.handleSelectionClick}
                list={listView}
                selected={selected}
                viewAsset={this.visitAsset}
                section={{
                  key: section.section_key,
                  type: section.default_asset_type,
                }}
                isHovered={isHovered}
                insertCaretDirection={insertCaretDirection}
                onVisitAsset={this.visitAsset}
                reorderable={reorderable}
                activeLabel={{
                  key: activeLabelKey,
                  name: activeLabelName,
                }}
                onDragComplete={onDragComplete}
                enableContactSheets={enableContactSheets}
              />
            </div>
          );

          if (labelsDrawerOpen) {
            content = connectDragSource(content);
          }

          if (reorderable) {
            content = connectDropTarget(content);
          }

          return content;
        }}
      </SectionsContext.Consumer>
    );
  }
}
Asset.propTypes = {
  asset: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    attributes: PropTypes.shape({
      name: PropTypes.string,
    }),
  }).isRequired,
  selected: PropTypes.bool.isRequired,
  section: PropTypes.shape({
    section_key: PropTypes.string,
    brandfolder_id: PropTypes.number,
    default_asset_type: PropTypes.string,
  }).isRequired,
  reorderable: PropTypes.bool,
  connectDropTarget: PropTypes.func.isRequired,
  insertCaretDirection: PropTypes.oneOf(['', 'top', 'bottom', 'left', 'right']),
  toggleSelected: PropTypes.func.isRequired,
  shiftSelect: PropTypes.func.isRequired,
  enableContactSheets: PropTypes.bool,
  /* eslint-disable react/no-unused-prop-types */
  onMove: PropTypes.func,
  onDrop: PropTypes.func,
  onDragComplete: PropTypes.func,
  connectDragSource: PropTypes.func,
  connectDragPreview: PropTypes.func,
  isHovered: PropTypes.bool,
  isDragging: PropTypes.bool,
  selectedAssetKeys: PropTypes.instanceOf(Set),
  /* eslint-enable react/no-unused-prop-types */
};

Asset.defaultProps = {
  reorderable: false,
  onMove: () => {},
  onDragComplete: () => {},
  connectDragSource: () => {},
  connectDragPreview: () => {},
  onDrop: () => {},
  isHovered: false,
  isDragging: false,
  insertCaretDirection: '',
  selectedAssetKeys: new Set(),
  enableContactSheets: false,
};

const assetTarget = {
  hover(props, monitor) {
    const item = monitor.getItem();
    const hoverId = props.asset.id;
    const pointerOffset = monitor.getClientOffset();

    props.onMove(item, hoverId, pointerOffset);
  },
  drop(props, monitor) {
    const item = monitor.getItem();
    const dropId = props.asset.id;

    props.onDrop(item, dropId);
  },
  canDrop(props, monitor) {
    const item = monitor.getItem();
    // Keep users from dropping between sections for now
    return item.sectionId === props.section.section_key;
  }
};

const dragSource = {
  beginDrag(props) {
    const { index, section, asset, selectedAssetKeys } = props;
    const { name, attachment_count: attachmentCount } = asset.attributes;

    // This is gross, I know, but it's necessary.
    document.querySelector('.labels-drawer-container').classList.add('highlighted');

    return {
      index,
      id: asset.id,
      sectionId: section.section_key,
      name,
      attachmentCount,
      reorder: false,
      selectedAssetKeys,
    };
  },

  endDrag() {
    document.querySelector('.labels-drawer-container').classList.remove('highlighted');
  }
};

const dragCollect = (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging(),
  connectDragPreview: connect.dragPreview(),
});

const dropCollect = (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isHovered: monitor.isOver(),
});

export default DropTarget('asset-reorder', assetTarget, dropCollect)(
  DragSource('asset-label', dragSource, dragCollect)(Asset)
);
